import { render, staticRenderFns } from "./ExtraContentPicker.vue?vue&type=template&id=2bbbb43e&scoped=true"
import script from "./ExtraContentPicker.vue?vue&type=script&lang=js"
export * from "./ExtraContentPicker.vue?vue&type=script&lang=js"
import style0 from "./ExtraContentPicker.vue?vue&type=style&index=0&id=2bbbb43e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbbb43e",
  null
  
)

export default component.exports